<template>
	<div class="card series-tab has-elements-visible-on-hover clickable clickable--no-hover"
		:class="getClass"
		@click="seriesClickedHandler">
		<div class="card-header series-title" :style="{'--color': colorTab}">{{ series.title }}</div>
		<div class="updates-ribbon">
			<span>{{ $t('updated') }}</span>
		</div>
		<div class="series-content position-relative">
			<div class="series-icons position-absolute mt-1 ml-1">
				<i v-if="series.includedInPendrive" :title="$t('series_included_in_pendrive')" class="fab fa-usb ml-1 text-dark"></i>
				<i v-if="series.hasStreamVideos" :title="$t('series_has_videos_in_stream')" class="fab fa-youtube ml-1 text-dark"></i>
			</div>
			<div class="series-image my-2">
				<img :title="series.description" :src="seriesImage" class="card-img-top"/>
			</div>
			<div class="card-body series-body visible-on-hover position-absolute p-3">
				<div v-if="series.shortDescription" class="series-description mb-2">{{ series.shortDescription }}</div>
				<div v-else class="series-description mb-2 text-secondary font-italic">{{ $t('description_not_available') }}</div>
				<div class="series-versions"><strong>{{ $t('versions') }}:</strong> {{ series.versions.map(v => v.title).join(', ') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['series', 'colorTab'],

	computed: {
		seriesImage() {
			return `/products-homepage/assets/img/SitesAssets/HomeTabs/${this.series.url}.jpg`;
		},

		getClass() {
			let hasUpdates = (this.series.family.searchForUpdates && this.series.hasUpdates) ? 'has-updates' : '';
			if (this.series.isDiscontinued) {
				return `discontinued ${hasUpdates}`;
			}
			if (this.series.isUnderDevelopment) {
				return `under-development ${hasUpdates}`;
			}
			return hasUpdates;
		},
	},

	methods: {
		seriesClickedHandler() {
			this.$emit('seriesClicked', this.series);
		},
	},
};
</script>

<style lang="scss">
@font-face {
	font-family: 'Univers LT Std BoldCn';
	src: url('/src/assets/fonts/UniversLTStd-BoldCn.woff2')
			format('woff2'),
		url('/src/assets/fonts/UniversLTStd-BoldCn.woff')
			format('woff');
	font-weight: bold;
	font-style: normal;
}

@font-face {
	font-family: 'Univers LT Std Cn';
	src: url('/src/assets/fonts/UniversLTStd-Cn.woff2')
			format('woff2'),
		url('/src/assets/fonts/UniversLTStd-Cn.woff')
			format('woff');
	font-weight: normal;
	font-style: normal;
}
	$discontinued-color-background: #999;
	$discontinued-color-foreground: #666;
	$under-development-color-background: #333;
	$shadow-color: #666;
	$tab-border-color: rgba(0, 0, 0, 0.5);

	.series-icons {
		> i {
			text-shadow: 2px 2px 3px #fff;
		}
	}

	.series-tab {
		align-self: flex-start;
		box-sizing: content-box;
		font-family: 'Univers LT Std Cn';
		position: relative;
		width: 190px;
		z-index: 10;
		.series-body {
			top: 0;
		}

		.series-description {
			font-size: 16px;
			letter-spacing: -1px;
			line-height: 20px;
		}

		.series-image {
			text-align: center;

			img {
				height: 128px;
				width: 150px;
			}
		}

		.series-title {
			color: #fff;
			font-size: 16px;
			text-align: center;
			padding: 0.5rem;
			background-color: var(--color);
		}

		.series-versions {
			font-size: 16px;
			text-shadow: 0 0 2px white;
		}

		&:hover {
			box-shadow: 1px 3px 3px $shadow-color;
			transform: scale(1.1);
			z-index: 20;

			.series-icons,
			.series-image {
				opacity: 0.25;
			}
		}

		&.card {
			border-color: $tab-border-color;
			transition: transform 0.2s ease;
		}

		&.discontinued {
			.series-title {
				background-color: $discontinued-color-background;
			}
		}

		&.under-development {
			.series-title {
				background-color: $under-development-color-background;
			}
		}

		&.has-updates {
			.updates-ribbon {
				display: block;
			}
		}
	}

	.updates-ribbon {
		display: none;
		font-size: 10px;
		height: 100px;
		overflow: hidden;
		position: absolute;
			right: 0;
			top: 0;
		width: 100px;
		z-index: 1;
		> span {
			box-shadow: -1px 1px 3px $shadow-color;
			background-color: green;
			color: white;
			height: 16px;
			line-height: 16px;
			position: absolute;
				right: -23px;
				top: 19px;
			text-align: center;
			text-transform: uppercase;
			transform: rotate(45deg);
			width: 100px;
		}
	}
</style>
